<script lang="ts">
  import { FileItemNodeProps } from "../models/props";
  import FileItemNode  from "./FileItemNode.svelte";

	let {
		item,
		parentPath,
		expanded,
		toggle,
		currentPath,
		onFileClick
	} : FileItemNodeProps= $props();

	const fullPath = [...parentPath, item.name];
	const pathKey = fullPath.join('/');

	const isExpanded = $derived(expanded.has(pathKey));
	const isActive = $derived(currentPath.join('/') === pathKey);
</script>

<div>
	<div
		class="w-full flex items-center space-x-2 px-2 py-1.5 rounded hover:bg-gray-100 transition-colors text-left {isActive ? 'bg-blue-50' : ''}"
		onclick={() => {
			if (item.type === 'folder') {
				console.log('Toggling:', pathKey, 'Has children:', !!item.children, 'Children count:', item.children?.length);
				toggle(pathKey);
			} else {
				onFileClick(item);
			}
		}}
	>
		{#if item.type === 'folder'}
			<svg
				class="w-4 h-4 text-gray-600 transition-transform {isExpanded ? 'rotate-90' : ''}"
				fill="currentColor"
				viewBox="0 0 20 20"
			>
				<path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
			</svg>

			<svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
				<path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"/>
			</svg>
		{:else}
			<span class="w-4"></span>
			<svg class="w-4 h-4 text-gray-600" fill="currentColor" viewBox="0 0 20 20">
				<path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clip-rule="evenodd"/>
			</svg>
		{/if}

		<span class="text-sm text-gray-800 truncate">{item.name}</span>
		<!-- <span class="text-xs text-red-500">[{isExpanded ? 'EXP' : 'COL'}]</span> -->
	</div>

	{#if item.type === 'folder' && item.children && isExpanded}
		<div class="ml-4 mt-1 space-y-1">
			{#each item.children as child}
				<FileItemNode
					item={child}
					parentPath={fullPath}
					expanded={expanded}
					toggle={toggle}
					currentPath={currentPath}
					onFileClick={onFileClick}
				/>
			{/each}
		</div>
	{/if}
</div>
